import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from './Modal';
import classnames from 'classnames';

import * as uiActions from '../../actions/ui';

import { selectModalType } from '../../selectors/modals';
import stylesAddToPlaylistModal from './AddToPlaylistModal.css';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import LoadingIndicator from '../common/LoadingIndicator';
import CancelButton from '../messages/CancelButton';
import CapacitorRipple from '../capacitor/Ripple';
import { selectDeleteTracksModalState } from '../../selectors/client';

class DeleteTracksModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    trackCount: PropTypes.number,
    onConfirm: PropTypes.func,
  };

  state = {
    isLoading: false,
  };

  onDeleteTracksClick = async () => {
    const { onConfirm, hideModal } = this.props;

    if (onConfirm) {
      this.setState({ isLoading: true });
      try {
        await onConfirm();
      } finally {
        this.setState({ isLoading: false });
      }
    }
    hideModal();
  };

  render() {
    const { isOpen, hideModal, trackCount } = this.props;
    const { isLoading } = this.state;
    const deleteButtonClassNames = classnames('c-btn', stylesAddToPlaylistModal.deleteButton);
    const cancelButtonClassNames = classnames(
      'c-btn c-btn--has-outline',
      stylesAddToPlaylistModal.cancelButton
    );

    return (
      <Modal
        isOpen={isOpen}
        onClose={hideModal}
        onRequestClose={hideModal}
        contentLabel="delete-tracks-modal"
      >
        <section className={stylesAddToPlaylistModal.modalDeletePlaylist}>
          <div className={stylesAddToPlaylistModal.createPlaylist}>
            <div className={stylesAddToPlaylistModal.body}>
              <h1 className="fz--beta">
                <FormattedMessage
                  id="playlist.edit-modal.delete-tracks.header"
                  defaultMessage="{count, plural, one {Delete Track} other {Delete Tracks}}"
                  values={{ count: trackCount || 0 }}
                />
              </h1>
              <p>
                <FormattedMessage
                  id="playlist.edit-modal.delete-tracks.text"
                  defaultMessage="Are you sure you want to delete {count} {count, plural, one {track} other {tracks}}?"
                  values={{ count: trackCount || 0 }}
                />
              </p>
            </div>
            <div className={stylesAddToPlaylistModal.buttonWrapper}>
              <button
                className={cancelButtonClassNames}
                onClick={hideModal}
                data-test="delete-tracks-modal.cancel-btn"
              >
                <CapacitorRipple />
                <CancelButton />
              </button>
              <button
                className={deleteButtonClassNames}
                onClick={this.onDeleteTracksClick}
                data-test="delete-tracks-modal.delete-btn"
                disabled={isLoading}
              >
                <CapacitorRipple />
                <LoadingIndicator isLoading={isLoading} className="hideText" />
                <FormattedMessage id="playlist.edit-modal.delete.button" defaultMessage="Delete" />
              </button>
            </div>
          </div>
        </section>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const deleteTracksState = selectDeleteTracksModalState(state);
  return {
    isOpen: selectModalType(state) === 'DELETE_TRACKS_MODAL',
    trackCount: deleteTracksState.trackCount || 0,
    onConfirm: deleteTracksState.onConfirm,
  };
}

export default compose(
  connect(mapStateToProps, {
    hideModal: uiActions.hideModal,
  })
)(DeleteTracksModal);
